var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, IconButton, Typography, useTheme } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import React, { useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { ArchiveBold, CheckCircleBold } from 'solar-icon-set';
import { AppConsts } from '../../../../application/common/constants/app-consts';
import { getFilteredStringOperators } from '../../../../application/common/helpers/grid-filter-operators';
import { useApproveMachineDocumentMutation, useArchiveMachineDocumentMutation, useGetNewPaginatedMachineDocumentsQuery } from '../../../../application/features/machine-documents/machine-document-api';
import { useGetActiveMachinesWithModelsQuery } from '../../../../application/features/machines/machine-api';
import { useAppSelector } from '../../../../application/store/useStore';
import useTranslate from '../../../../localization/helpers';
import ConfirmDialog from '../../../components/ConfirmDialog';
import ProtectedElement from '../../../components/ProtectedElement';
import EyeIcon from '../../../icons/components/eye-icon';
import { Permissions } from '../../../permissions';
import ViewDocument from '../view-document';
import NewTabCards from './new-tab-cards';
import NewTabGrid from './new-tab-datagrid';
var NewTab = function (_a) {
    var _b;
    var isscreen600900 = _a.isscreen600900, iscreen9001200 = _a.iscreen9001200, isXs = _a.isXs, isscreen600900Landscape = _a.isscreen600900Landscape, isscreen9001200Landscape = _a.isscreen9001200Landscape, isSm = _a.isSm, isMd = _a.isMd, isIpadMini = _a.isIpadMini, isIpadMiniLandscape = _a.isIpadMiniLandscape, openFilterDrawer = _a.openFilterDrawer, setOpenFilterDrawer = _a.setOpenFilterDrawer;
    var theme = useTheme();
    var translate = useTranslate().translate;
    var currentCompany = useAppSelector(function (state) { return state.common; }).currentCompany;
    var _c = __read(useState(false), 2), archiveDialogOpen = _c[0], setArchiveDialogOpen = _c[1];
    var _d = __read(useState(false), 2), approveDialogOpen = _d[0], setApproveDialogOpen = _d[1];
    var _e = __read(useState(false), 2), archiveMultipleDialogOpen = _e[0], setArchiveMultipleDialogOpen = _e[1];
    var _f = __read(useState(false), 2), approveMultipleDialogOpen = _f[0], setApproveMultipleDialogOpen = _f[1];
    var _g = __read(useState(null), 2), selectedRow = _g[0], setSelectedRow = _g[1];
    var _h = __read(useState([]), 2), selectedDocuments = _h[0], setSelectedDocuments = _h[1];
    var _j = __read(useState({
        items: []
    }), 2), filterModel = _j[0], setFilterModel = _j[1];
    var _k = __read(useState({ isOpen: false }), 2), viewDocument = _k[0], setViewDocument = _k[1];
    var onViewDocument = function (document) {
        return setViewDocument({ isOpen: true, document: document });
    };
    var _l = __read(useState({
        fileName: '',
        machineModels: [],
        sortField: AppConsts.DEFAULT_SORT_FIELD,
        sortDirection: AppConsts.DEFAULT_SORT_DIRECTION,
        page: AppConsts.DEFAULT_PAGE_NUMBER,
        pageSize: AppConsts.DEFAULT_PAGE_SIZE,
        filterField: undefined,
        filterOperator: undefined,
        filterValue: undefined
    }), 2), machineDocumentFilters = _l[0], setMachineDocumentFilters = _l[1];
    var _m = __read(useApproveMachineDocumentMutation(), 2), triggerApproveDocument = _m[0], _o = _m[1], isApproveSuccess = _o.isSuccess, isApproveLoading = _o.isLoading;
    var _p = __read(useArchiveMachineDocumentMutation(), 2), triggerArchiveDocument = _p[0], _q = _p[1], isArchiveSuccess = _q.isSuccess, isArchiveLoading = _q.isLoading;
    var _r = useGetNewPaginatedMachineDocumentsQuery(machineDocumentFilters, {
        refetchOnMountOrArgChange: true
    }), data = _r.data, isFetching = _r.isFetching;
    var _s = (data !== null && data !== void 0 ? data : {}).items, machineDocuments = _s === void 0 ? [] : _s;
    var _t = useGetActiveMachinesWithModelsQuery({
        companyId: currentCompany === null || currentCompany === void 0 ? void 0 : currentCompany.id,
        filterByCompany: true
    }), _u = _t.data, machinesWithModels = _u === void 0 ? [] : _u, machinesFetching = _t.isLoading;
    var _v = useForm({
        defaultValues: {
            fileName: '',
            machineModels: []
        }
    }), control = _v.control, getValues = _v.getValues, handleSubmit = _v.handleSubmit, reset = _v.reset;
    var openArchiveDialog = function (row) {
        setSelectedRow(row);
        setArchiveDialogOpen(true);
        setApproveDialogOpen(false);
    };
    var openApproveDialog = function (row) {
        setSelectedRow(row);
        setApproveDialogOpen(true);
        setArchiveDialogOpen(false);
    };
    var handleArchiveMultipleDocs = function () {
        if (selectedDocuments.length > 0) {
            var dto = {
                machineWithDocumentIdsAndModels: selectedDocuments.map(function (doc) { return ({
                    machineDocumentId: doc.documentId,
                    machineWithModels: [
                        {
                            machineId: doc.matchingMachineId,
                            modelNumber: doc.matchingModelNumber
                        }
                    ]
                }); })
            };
            triggerArchiveDocument(dto);
            setSelectedDocuments([]);
        }
    };
    var handleApproveMultipleDocs = function () {
        if (selectedDocuments.length > 0) {
            var dto = {
                machineWithDocumentIdsAndModels: selectedDocuments.map(function (doc) { return ({
                    machineDocumentId: doc.documentId,
                    machineWithModels: [
                        {
                            machineId: doc.matchingMachineId,
                            modelNumber: doc.matchingModelNumber
                        }
                    ]
                }); })
            };
            triggerApproveDocument(dto);
            setSelectedDocuments([]);
        }
    };
    useEffect(function () {
        if (isArchiveSuccess) {
            enqueueSnackbar(selectedDocuments.length > 1
                ? translate('knowledge.archiveMultipleSuccess')
                : translate('knowledge.archiveSuccess'), {
                autoHideDuration: 3000,
                variant: 'success',
                anchorOrigin: { horizontal: 'right', vertical: 'top' }
            });
            setSelectedRow(null);
            setSelectedDocuments([]);
            setArchiveDialogOpen(false);
            setArchiveMultipleDialogOpen(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isArchiveSuccess]);
    useEffect(function () {
        if (isApproveSuccess) {
            enqueueSnackbar(selectedDocuments.length > 1
                ? translate('knowledge.approveMultipleSuccess')
                : translate('knowledge.approveSuccess'), {
                autoHideDuration: 3000,
                variant: 'success',
                anchorOrigin: { horizontal: 'right', vertical: 'top' }
            });
            setSelectedRow(null);
            setSelectedDocuments([]);
            setApproveDialogOpen(false);
            setApproveMultipleDialogOpen(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isApproveSuccess]);
    var rowCountRef = React.useRef((_b = data === null || data === void 0 ? void 0 : data.totalCount) !== null && _b !== void 0 ? _b : 0);
    var rowCount = useMemo(function () {
        if ((data === null || data === void 0 ? void 0 : data.totalCount) !== undefined) {
            rowCountRef.current = data === null || data === void 0 ? void 0 : data.totalCount;
        }
        return rowCountRef.current;
    }, [data === null || data === void 0 ? void 0 : data.totalCount]);
    var handleSelectionChange = function (selectedIds) {
        var selectedRows = machineDocuments.filter(function (row) {
            return selectedIds.ids.has(row.id);
        });
        setSelectedDocuments(selectedRows);
    };
    var handlePaginationModelChange = function (model) {
        setMachineDocumentFilters(function (prev) { return (__assign(__assign({}, prev), { page: model.page + 1, pageSize: model.pageSize })); });
    };
    var filterDocuments = function () {
        setMachineDocumentFilters(__assign(__assign({}, machineDocumentFilters), { fileName: getValues('fileName'), machineModels: getValues('machineModels') }));
    };
    var handleArchive = function () {
        if (selectedRow) {
            var dto = {
                machineWithDocumentIdsAndModels: [
                    {
                        machineDocumentId: selectedRow.documentId,
                        machineWithModels: [
                            {
                                machineId: selectedRow.matchingMachineId,
                                modelNumber: selectedRow.matchingModelNumber
                            }
                        ]
                    }
                ]
            };
            triggerArchiveDocument(dto);
        }
    };
    var handleApprove = function () {
        if (selectedRow) {
            var dto = {
                machineWithDocumentIdsAndModels: [
                    {
                        machineDocumentId: selectedRow.documentId,
                        machineWithModels: [
                            {
                                machineId: selectedRow.matchingMachineId,
                                modelNumber: selectedRow.matchingModelNumber
                            }
                        ]
                    }
                ]
            };
            triggerApproveDocument(dto);
        }
    };
    var handleFilterModelChange = function (model) {
        if (model.items.length > 0) {
            var filterItem_1 = model.items[0];
            if (filterItem_1.operator !== 'isEmpty' &&
                filterItem_1.operator !== 'isNotEmpty' &&
                (filterItem_1.value === '' ||
                    (Array.isArray(filterItem_1.value) && filterItem_1.value.length === 0) ||
                    filterItem_1.value === undefined)) {
                setMachineDocumentFilters(function (prev) { return (__assign(__assign({}, prev), { filterField: undefined, filterOperator: undefined, filterValue: undefined })); });
            }
            else {
                setMachineDocumentFilters(function (prev) {
                    var _a;
                    return (__assign(__assign({}, prev), { filterField: filterItem_1.field, filterOperator: filterItem_1.operator, filterValue: (_a = filterItem_1.value) === null || _a === void 0 ? void 0 : _a.toString() }));
                });
            }
        }
        else {
            // When model.items is empty, clear all filters
            setMachineDocumentFilters(function (prev) { return (__assign(__assign({}, prev), { filterField: undefined, filterOperator: undefined, filterValue: undefined })); });
        }
        setFilterModel(model);
    };
    var handleSortModelChange = function (model) {
        setMachineDocumentFilters(function (prev) {
            var _a, _b, _c, _d;
            return (__assign(__assign({}, prev), { sortField: (_b = (_a = model[0]) === null || _a === void 0 ? void 0 : _a.field) !== null && _b !== void 0 ? _b : AppConsts.DEFAULT_SORT_FIELD, sortDirection: (_d = (_c = model[0]) === null || _c === void 0 ? void 0 : _c.sort) !== null && _d !== void 0 ? _d : AppConsts.DEFAULT_SORT_DIRECTION }));
        });
    };
    var machinesColumns = [
        {
            field: 'title',
            headerName: translate('knowledge.title'),
            flex: 1,
            minWidth: isXs ? 150 : isscreen600900 ? 400 : isMd ? 150 : undefined,
            filterOperators: getFilteredStringOperators(),
            renderCell: function (params) { return (_jsx(Box, { display: 'flex', alignItems: 'center', gap: 1, my: 1.7, children: _jsx(Typography, { title: params.row.title, variant: 'body2', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', children: params.row.title }) })); }
        },
        {
            field: 'fileName',
            headerName: translate('knowledge.documentTitle'),
            flex: 1,
            minWidth: isXs ? 150 : isscreen600900 ? 200 : isMd ? 150 : undefined,
            filterOperators: getFilteredStringOperators(),
            renderCell: function (params) { return (_jsx(Box, { display: 'flex', alignItems: 'center', gap: 1, my: 1.7, onClick: function () { return onViewDocument(params.row); }, sx: { cursor: 'pointer' }, children: _jsx(Typography, { title: params.row.fileName, variant: 'body2', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', children: params.row.fileName }) })); }
        },
        {
            field: 'aiSummary',
            headerName: translate('knowledge.aiSummary'),
            flex: 1,
            filterable: false,
            disableColumnMenu: true,
            sortable: false,
            minWidth: isXs ? 150 : isscreen600900 ? 200 : isMd ? 150 : undefined
        },
        {
            field: 'createdByName',
            headerName: translate('knowledge.createdBy'),
            flex: 1,
            minWidth: isXs ? 150 : isscreen600900 ? 200 : isMd ? 150 : undefined
        },
        {
            field: 'companyName',
            headerName: translate('common.company'),
            flex: 1,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined
        },
        {
            field: 'machineName',
            headerName: translate('common.asset'),
            flex: 1,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            renderCell: function (params) { return (_jsx(Box, { display: 'flex', alignItems: 'center', gap: 1, marginTop: params.row.modelNumber ? '4.5px' : '14px', children: _jsxs(Box, { display: 'flex', justifyContent: 'center', flexDirection: 'column', flex: 1, minWidth: 0, children: [_jsx(Typography, { title: params.row.machineName, variant: 'body2', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', children: params.row.machineName }), params.row.modelNumber ? (_jsx(Typography, { title: params.row.modelNumber, variant: 'body2', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', sx: { color: theme.palette.text.secondary }, children: params.row.modelNumber })) : (_jsx(_Fragment, {}))] }) })); }
        },
        {
            field: 'matchingMachineName',
            headerName: translate('knowledge.matchedAsset'),
            flex: 1,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            renderCell: function (params) { return (_jsx(Box, { display: 'flex', alignItems: 'center', gap: 1, marginTop: params.row.matchingModelNumber ? '4.5px' : '14px', children: _jsxs(Box, { display: 'flex', justifyContent: 'center', flexDirection: 'column', flex: 1, minWidth: 0, children: [_jsx(Typography, { title: params.row.matchingMachineName, variant: 'body2', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', children: params.row.matchingMachineName }), params.row.matchingModelNumber ? (_jsx(Typography, { title: params.row.matchingModelNumber, variant: 'body2', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', sx: { color: theme.palette.text.secondary }, children: params.row.matchingModelNumber })) : (_jsx(_Fragment, {}))] }) })); }
        },
        {
            field: 'action',
            headerName: '',
            align: 'right',
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 0.7 : 1,
            minWidth: isXs ? 1 : isMd ? 1 : isscreen600900 ? 130 : 150,
            renderCell: function (params) { return (_jsxs(Box, { display: 'flex', gap: 0.5, alignItems: 'center', mt: 0.5, justifyContent: 'flex-end', children: [_jsx(IconButton, { onClick: function () { return onViewDocument(params.row); }, size: 'medium', children: _jsx(EyeIcon, {}) }), _jsx(ProtectedElement, { permissions: [Permissions.Knowledge.Update], children: _jsx(IconButton, { onClick: function () {
                                openArchiveDialog(params.row);
                            }, size: 'medium', sx: { color: theme.palette.secondary.dark }, children: _jsx(ArchiveBold, { size: 24 }) }) }), _jsx(ProtectedElement, { permissions: [Permissions.Knowledge.Create], children: _jsx(IconButton, { onClick: function (event) {
                                event.stopPropagation();
                                openApproveDialog(params.row);
                            }, size: 'medium', sx: { color: theme.palette.primary.dark }, children: _jsx(CheckCircleBold, { size: 24 }) }) })] })); }
        }
    ];
    return (_jsxs(_Fragment, { children: [isXs || isIpadMini || isIpadMiniLandscape ? (_jsx(NewTabCards, { filterDocuments: filterDocuments, control: control, isXs: isXs, isScreen9001200: iscreen9001200, isscreen600900Landscape: isscreen600900Landscape, isscreen600900: isscreen600900, iscreen9001200: iscreen9001200, isscreen9001200Landscape: isscreen9001200Landscape, isIpadMini: isIpadMini, isIpadMiniLandscape: isIpadMiniLandscape, openFilterDrawer: openFilterDrawer, setOpenFilterDrawer: setOpenFilterDrawer, isFetching: isFetching, machinesFetching: machinesFetching, machinesWithModels: machinesWithModels, machineDocuments: machineDocuments, selectedDocuments: selectedDocuments, setSelectedDocuments: setSelectedDocuments, machineDocumentFilters: machineDocumentFilters, setMachineDocumentFilters: setMachineDocumentFilters, setOpenMultipleApproveDialog: setApproveMultipleDialogOpen, setOpenMultipleArchiveDialog: setArchiveMultipleDialogOpen, openApproveDialog: openApproveDialog, openArchiveDialog: openArchiveDialog, onViewDocument: onViewDocument, handleSubmit: handleSubmit, reset: reset })) : (_jsx(NewTabGrid, { control: control, filterDocuments: filterDocuments, isFetching: isFetching, machinesFetching: machinesFetching, machinesWithModels: machinesWithModels, rows: machineDocuments, columns: machinesColumns, onSortModelChange: handleSortModelChange, rowCount: rowCount, paginationModel: {
                    page: machineDocumentFilters.page - 1,
                    pageSize: machineDocumentFilters.pageSize
                }, onPaginationModelChange: handlePaginationModelChange, openFilterDrawer: openFilterDrawer, setOpenFilterDrawer: setOpenFilterDrawer, onSelectionChange: handleSelectionChange, setOpenMultipleApproveDialog: setApproveMultipleDialogOpen, setOpenMultipleArchiveDialog: setArchiveMultipleDialogOpen, selectedDocuments: selectedDocuments, filterModel: filterModel, handleFilterModelChange: handleFilterModelChange, isXs: isXs, isScreen9001200: iscreen9001200, isscreen600900Landscape: isscreen600900Landscape, isscreen600900: isscreen600900, iscreen9001200: iscreen9001200, isscreen9001200Landscape: isscreen9001200Landscape })), archiveDialogOpen && (_jsx(ConfirmDialog, { open: archiveDialogOpen, disabled: isArchiveLoading, title: translate('knowledge.archiveTitle'), content: translate('knowledge.archiveContent'), mode: 'inherit', confirmButtonText: translate('knowledge.archive'), closeButtonText: translate('actions.cancel'), onClose: function () {
                    setArchiveDialogOpen(false);
                    setSelectedRow(null);
                }, onConfirm: handleArchive })), approveDialogOpen && (_jsx(ConfirmDialog, { open: approveDialogOpen, disabled: isApproveLoading, title: translate('knowledge.approveTitle'), content: translate('knowledge.approveContent'), mode: 'inherit', confirmButtonText: translate('knowledge.approve'), closeButtonText: translate('actions.cancel'), onClose: function () {
                    setApproveDialogOpen(false);
                    setSelectedRow(null);
                }, onConfirm: handleApprove })), archiveMultipleDialogOpen && (_jsx(ConfirmDialog, { open: archiveMultipleDialogOpen, disabled: isArchiveLoading, title: translate('knowledge.archiveTitle'), content: selectedDocuments.length > 1
                    ? translate('knowledge.archiveContents')
                    : translate('knowledge.archiveContent'), mode: 'inherit', confirmButtonText: translate('knowledge.archive'), closeButtonText: translate('actions.cancel'), onClose: function () {
                    setArchiveMultipleDialogOpen(false);
                }, onConfirm: handleArchiveMultipleDocs })), approveMultipleDialogOpen && (_jsx(ConfirmDialog, { open: approveMultipleDialogOpen, disabled: isApproveLoading, title: translate('knowledge.approveTitle'), content: selectedDocuments.length > 1
                    ? translate('knowledge.approveContents')
                    : translate('knowledge.approveContent'), mode: 'inherit', confirmButtonText: translate('knowledge.approve'), closeButtonText: translate('actions.cancel'), onClose: function () {
                    setApproveMultipleDialogOpen(false);
                }, onConfirm: handleApproveMultipleDocs })), viewDocument.document && (_jsx(ViewDocument, { documentId: viewDocument.document.id, filePath: viewDocument.document.filePath, title: viewDocument.document.title, open: viewDocument.isOpen, onClose: function () { return setViewDocument({ isOpen: false }); } }))] }));
};
export default NewTab;
